import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';
import { UserDto } from 'modules/roles-manager/domain/interfaces/user';

/**
 * REST-операции над самим игроком. Раньше жил в `modules/teams` вместе с
 * `changeRole` — сменой роли в составе команды; это разные сущности, поэтому
 * фото осталось здесь, а роль уехала в `teams/domain/resources/team-participants-resource.ts`.
 */
class PlayersResource extends Resource {
  constructor() {
    super('users', httpResource);
  }

  public async uploadPhoto(photo: File, playerId: number, tournamentId: number): Promise<UserDto> {
    const formData = new FormData();

    formData.append('image', photo);
    formData.append('tournamentId', `${tournamentId}`);

    return await this.child(`${playerId}/photo`).post(formData);
  }
}

const playersResource = new PlayersResource();
export default playersResource;
